import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import { colorCodesForAvatar } from "../../../../constants/index";
import { chracterPosition } from "../../../../utils/index";

export default function AgentNameCell({ name, jobTitle, avatar }) {
  const letter = (name || "").substring(0, 1).toUpperCase();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        overflow: "hidden",
        minWidth: 0,
        width: "100%",
      }}
    >
      {avatar ? (
        <Avatar src={avatar} alt={name} sx={{ width: 32, height: 32, flexShrink: 0 }} />
      ) : (
        <Avatar
          sx={{
            width: 32,
            height: 32,
            fontSize: 13,
            flexShrink: 0,
            bgcolor: colorCodesForAvatar[chracterPosition(letter)] || "#405261",
          }}
        >
          {letter}
        </Avatar>
      )}
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          sx={{
            color: "#061522",
            fontSize: 14,
            fontWeight: 500,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {name}
        </Typography>
        {jobTitle ? (
          <Typography
            sx={{
              color: "#405261",
              fontSize: 12,
              fontWeight: 400,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {jobTitle}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
}
